import { render, staticRenderFns } from "./GardenerDelete.vue?vue&type=template&id=01ec15f6&scoped=true"
import script from "./GardenerDelete.vue?vue&type=script&lang=js"
export * from "./GardenerDelete.vue?vue&type=script&lang=js"
import style0 from "./GardenerDelete.vue?vue&type=style&index=0&id=01ec15f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ec15f6",
  null
  
)

export default component.exports